import { render, staticRenderFns } from "./SalaryChangesHistoryList.vue?vue&type=template&id=ddbed32c"
import script from "../../controllers/salary_changes_history/salary-changes-history-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/salary_changes_history/salary-changes-history-list.js?vue&type=script&lang=js&external"
import style0 from "./SalaryChangesHistoryList.vue?vue&type=style&index=0&id=ddbed32c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports